$(document).ready(function() {

    tabTimerStr()
});

var swiper = new Swiper('.swiper-brand', {
    pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
        lazy: true,
        observer: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});

new Swiper('.js-bannerBar-swiper', {
    lazy: true,
    observer: true,
    observeParents: true,
    preloadImages: false,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '"></span>';
        },
    },
    autoplay: {
        delay: 2500,
        disableOnInteraction: false,
    },
});

$('.js-select-motor-manufacturer').on('select2:select', function (e) {
    var data = $(this).find('option:selected').val();
    AjaxGetManufacturer(data,renderDisplacementSelect)

    swichAddMyBikeBtn()
});

$('.js-select-motor-displacement').on('select2:select', function (e) {
    var displacement = $(this).find('option:selected').val();
    var manufacturer = $(".js-select-motor-manufacturer option:selected").val();
    AjaxGetModel(manufacturer , displacement ,renderModelSelect)

    swichAddMyBikeBtn()
});

$('.js-select-motor-model').on('select2:select', function (e) {
    swichAddMyBikeBtn()
});

$(document).on( 'click','.js-model-navlink',function(){
    $('.js-model-navlink').removeClass('active')
    $(this).addClass('active')
    var order = $(this).index()
    $('.js-model-target').removeClass('active')
    $('.js-model-target').eq(order).addClass('active')

    $('.js-model-productCount').text($(this).attr('count-data'))
    $('.js-model-link').attr('href' , $(this).attr('url-data'))
    $('.js-model-name').text($(this).find('small').text());
})

// 切換tab前啟動
$(document).on('show.bs.tab','.js-getTab-product',function(){
    var categoryId = $(this).attr('id').replace("category-",'').replace("-tab",'');
    var target = $($(this).attr('href'))

    // 為了解決點擊後高度變化的問題在點擊後 自動同步所有Tab內容高度
    

    // 若是原廠零件 擇要拋送不同參數
    if($(this).parents('.js-original-factory').length !== 0){
        AjaxGetMotoProduct(categoryId,target,renderCategoryTabSlider)
    }else{
        AjaxGetCategoryProduct(categoryId,target,renderCategoryTabSlider)
    }

})


function swichAddMyBikeBtn(){
    if(checkMyBikeDataComplete()){
        $('.js-add-myBike').removeAttr('disabled')
    }else{
        $('.js-add-myBike').attr('disabled','true')
    }
}

function checkMyBikeDataComplete(){
    var manufacturer = $('.js-select-motor-manufacturer option:selected').first().val();
    var displacement =$('.js-select-motor-displacement option:selected').first().val();
    var model = $('.js-select-motor-model option:selected').first().val();

    if(manufacturer == '-1' || !manufacturer){
        return false
    }

    if(displacement == '-1' || !displacement){
        return false
    }

    if(model == '-1' || !model){
        return false
    }

    return true
}

function cleanSelect2(selectName){
    $(selectName).empty();
    $(selectName).val(null).trigger('change');
}

function addDisplacementSelectTitle(){
    var title = {
        id: -1,
        text: 'cc數'
    };
    var DisplacementTitle = new Option(title.text, title.id, false, false);
    $('.js-select-motor-displacement').append(DisplacementTitle).trigger('change')

    // 將title 設置為禁用
    $(".js-select-motor-displacement option[value='-1']").attr('disabled',true);
}

function addModelSelectTitle(){
    var title = {
        id: -1,
        text: '型號'
    };
    var DisplacementTitle = new Option(title.text, title.id, false, false);
    $('.js-select-motor-model').append(DisplacementTitle).trigger('change')

    // 將title 設置為禁用
    $(".js-select-motor-model option[value='-1']").attr('disabled',true);
}

function renderDisplacementSelect(data){
    // 清空舊資料
    cleanSelect2('.js-select-motor-displacement')
    cleanSelect2('.js-select-motor-model')

    // 放入title
    addDisplacementSelectTitle()
    addModelSelectTitle()

    // 放入內容
    for(var key in data){
        var cc = {
            id: data[key],
            text: data[key]
        };

        var DisplacementSelect = new Option(cc.text, cc.id, false, false);
        $('.js-select-motor-displacement').append(DisplacementSelect).trigger('change');
    }
    // 車型套用禁用狀態
    $('.js-select-motor-model').attr('disabled',true);
    // 解除該選單的禁用狀態
    $('.js-select-motor-displacement').removeAttr('disabled');
}

function renderModelSelect(data){
    // 清空舊資料
    cleanSelect2('.js-select-motor-model')

    // 放入title
    addModelSelectTitle()

    // 放入內容
    for(var key in data){
        var cc = {
            id: data[key].key,
            text: data[key].name
        };
        var DisplacementSelect = new Option(cc.text, cc.id, false, false);
        $('.js-select-motor-model').append(DisplacementSelect).trigger('change');
    }

    // 解除該選單的禁用狀態
    $('.js-select-motor-model').removeAttr('disabled');
}

function renderCategoryTabSlider(data,target){

    // 獲得資料 整理成html
    var str = ''
    var items = JSON.parse(data)
    var targetElement = target.find('.swiper-container')

    items.forEach(element => {

        var itemsStr = ''

        element.forEach( subElement => {
            itemsStr += '<div class="col-2" style="flex: 0 0 20%; max-width: 20%">' + subElement + '</div>'
        })

        str += '<div class="swiper-slide mx-0 p-2 row">' + itemsStr + '</div>'
    });

    var html = '<div class="swiper-wrapper">' + str + '</div><div class="swiper-button-next"></div><div class="swiper-button-prev"></div>'

    targetElement.html(html);

    new Swiper(targetElement, {
            lazy: true,
            observer: true,
            observeParents: true,
            preloadImages: false,
            slidesPerView: 1,
            slidesPerGroup: 1,
            navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
}

function AjaxGetCategoryProduct(parameter,target,todo){

    // 1.驗證有值
    if(!parameter){
        return false
    }
    // 2.發送請求
    var url = 'api/getSuggestProducts?category=' + parameter

    $.ajax({
        'url': url,
        'type': 'GET',
        'async': false,
        // 暫時先異步
        success: function(data){
            todo(data,target)

            // 成功獲取資料後刪除 ajax拋送茅點 避免重複拋送
            $('#category-' + parameter + '-tab').removeClass('js-getTab-product');
        }
    })
}

function AjaxGetMotoProduct(parameter,target,todo){

    // 1.驗證有值
    if(!parameter){
        return false
    }
    // 2.發送請求
    var url = 'api/getSuggestProducts?moto=' + parameter + '&category=9000'

    $.ajax({
        'url': url,
        'type': 'GET',
        'async': false,
        // 暫時先異步
        success: function(data){
            todo(data,target)

            // 成功獲取資料後刪除 ajax拋送茅點 避免重複拋送
            $('#category-' + parameter + '-tab').removeClass('js-getTab-product');
        }
    })
}

function AjaxGetManufacturer(data,todo){
    // 1.驗證有值
    if(!data){
        return false
    }
    // 2.發送請求
    var url = "/api/motor/displacements?manufacturer=" + data
    $.ajax({
        'url' : url,
        'type' : 'get',
        success: function(data){
            // 3.獲取數據執行動作
            todo(data);
        }
    })
}

function AjaxGetModel(manufacturer , displacement , todo){
    // 1.驗證有值
    if(!manufacturer){
        return false
    }
    if(!displacement){
        return false
    }

    // 2.發送請求
    var url = "/api/motor/model?manufacturer=" + manufacturer + "&displacement=" + displacement

    $.ajax({
        'url' : url,
        'type' : 'get',
        success: function(data){
            todo(data)
        }
    })
}

function tabTimerStr(){
    var url = $('.js-model-navlink:first').attr('url-data');
    var count = $('.js-model-navlink:first').attr('count-data');
    var name = $('.js-model-navlink:first').text();

    $('.js-model-productCount').text(count);
    $('.js-model-link').attr('href' , url);
    $('.js-model-name').text(name);
}